<div class="details">
  @if (entity$ | async; as entity) {
    <div class="details__tab-nav">
      <jupiter-tab-header
        [tabs]="tabs"
        [tabId]="tabId"
        [canEditLayout]="!ui.panelIdInEditMode"
        [editMode]="ui.editMode"
        (panelAdded)="onPanelAdded($event)"
        (tabAdded)="onTabAdded($event)"
        (tabUpdated)="onTabUpdated($event)"
        (tabRemoved)="onTabRemoved($event)"
        (tabMoved)="onTabMoved($event)"
        (tabChange)="onTabChange($event)"
        (toggleEditMode)="onToggleEditMode()"
        (layoutCanceled)="onLayoutCanceled()"
        (layoutSaved)="onLayoutSaved()"
      ></jupiter-tab-header>
    </div>
    <div class="details__content" [class.loading]="ui.isLoading">
      <gridster [options]="gridOptions">
        <gridster-item [item]="item" *ngFor="let item of layout" (itemChange)="gridsterItemChange()">
          <div class="details__content__panel">
            <div class="details__content__panel__actions" *ngIf="ui.editMode">
              <ts-button
                type="icon"
                icon="delete"
                matTooltip="Delete me"
                class="delete-panel-handler"
                (mousedown)="$event.stopPropagation()"
                (click)="onRemovePanel(item)"
                color="basic"
              >
              </ts-button>
              <ts-button
                type="icon"
                color="basic"
                icon="drag_indicator"
                matTooltip="Drag me"
                class="panel-handler drag-handler"
              >
              </ts-button>
            </div>
            <div id="panel-placeholder" *cdkDragPlaceholder></div>
            <div
              class="height-100p"
              [ngClass]="{ 'panel-boundry': ui.editMode }"
              [class.not-editable]="ui.panelIdInEditMode !== null && item.panel.id !== ui.panelIdInEditMode"
            >
              <app-panel-host
                #panelHosts
                [panelDef]="item.panel"
                [model]="entity"
                [data]="data$ | async"
                [relatedTo]="relatedTo$ | async"
                (panelDefUpdated)="onPanelDefUpdated($event)"
                (dataUpdated)="onDataUpdated($event)"
                (editToggled)="onEditToggled($event)"
                (discardClicked)="onDiscardClicked($event)"
              ></app-panel-host>
            </div>
          </div>
        </gridster-item>
      </gridster>
    </div>
  } @else {
    <div class="h-full" jupiter-dashboard-loading></div>
  }
</div>
